import type { FundPublic, FundsViewRes, UserFollowedFundsRes } from '@/api/fund/queries';
import type { FundCarouselItem } from '@/api/fund-views/types';

type ReferencedFund =
  | UserFollowedFundsRes['followedFunds'][number]
  | FundsViewRes['fundViews'][number];

const DEFAULT_CURRENCY = 'USD';

const toMinInvest = (amount?: string | null) =>
  amount === undefined || amount === null ? null : Number(amount);

export const mapPublicFundToCarouselItem = (fund: FundPublic): FundCarouselItem => ({
  fundId: fund.id,
  fundName: fund.name ?? '',
  fundCurrency: fund.minInvestment?.currency || DEFAULT_CURRENCY,
  fundSize: fund.sizeInMillionsUsd,
  fundAum: fund.aumInMillionsUsd,
  returnInYear: fund.targetReturnRate,
  returnKind: 'target',
  minInvest: toMinInvest(fund.minInvestment?.amount),
  logoUrl: fund.entityLogoUrl,
  cardImageUrl: fund.cardImageUrl ?? fund.entityLogoUrl,
  entityName: fund.entityName,
  entityLogoUrl: fund.entityLogoUrl,
  slug: fund.slug,
});

export const mapReferencedFundToCarouselItem = (
  fund: ReferencedFund,
  publicFund?: FundPublic,
): FundCarouselItem => ({
  fundId: fund.fundId,
  fundName: fund.fundName,
  fundCurrency: publicFund?.minInvestment?.currency || DEFAULT_CURRENCY,
  fundSize: fund.fundSize ?? publicFund?.sizeInMillionsUsd ?? null,
  fundAum: publicFund?.aumInMillionsUsd ?? null,
  returnInYear: publicFund?.targetReturnRate ?? null,
  returnKind: 'target',
  minInvest: toMinInvest(publicFund?.minInvestment?.amount),
  logoUrl: fund.entityLogoUrl,
  cardImageUrl: publicFund?.cardImageUrl ?? fund.entityLogoUrl,
  entityName: fund.entityName,
  entityLogoUrl: fund.entityLogoUrl,
  slug: fund.slug,
});
